import { FunctionComponent, useState, useEffect, useRef } from "react";
import "./Session.scss";
import Table from "../../../../Components/Table/Table";
import CustomToolbar from "../../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../../Components/Button/ButtonField";
import { Columns } from "../../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import Dialog from "../../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../../../Assets/Images/edit.svg";
import IconButtonField from "../../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../../../Assets/Images/RefreshButton.svg";

// Form
import SessionForm from "./SessionForm";
import { ISession } from "./ISession";
import {
  clearSession_Crud,
  Session_Crud,
} from "../../../../Redux/Slices/CRM/Leads/Session/Session_crud";
import { SessionRead } from "../../../../Redux/Slices/CRM/Leads/Session/SessionRead";

// Redux slices (replace with yours)

const Session: FunctionComponent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteDialogData, setDeleteDialogData] = useState<ISession | null>(
    null
  );
  const [initialValues, setInitialValues] = useState<Partial<ISession>>({
    status: true,
  });

  const dispatch = useAppDispatch();
  const { data: sessionList } = useAppSelector((s) => s.SessionReadSlice);
  const { data: addOrUpdateResponse } = useAppSelector(
    (s) => s.SessionCrudSlice
  );

  const formRef = useRef<HTMLFormElement>(null);

  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "description",
      renderHeader: () => <b>Description</b>,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    // { field: "tutor_id", renderHeader: () => <b>Tutor ID</b>, flex: 1 },
    {
      field: "session_date",
      renderHeader: () => <b>Session Date</b>,
      flex: 1,
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    },
    { field: "mode", renderHeader: () => <b>Mode</b>, flex: 1 },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      cellClassName: (p) =>
        `activename ${p.row.status ? "active" : "inactive"}`,
      valueFormatter: (p) => (p.value ? "Active" : "Inactive"),
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ISession>) => (
        <>
          <IconButtonField
            onClick={() => {
              setInitialValues(params.row);
              setDialogOpen(true);
            }}
          >
            <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
          </IconButtonField>

          <IconButtonField
            onClick={() => {
              dispatch(clearSession_Crud());
              setDeleteDialogData(params.row);
              setDeleteDialogOpen(true);
            }}
          >
            <SvgIcon component={Delete} inheritViewBox />
          </IconButtonField>
        </>
      ),
    },
  ];

const data = sessionList?.data ?? [];
const sessions: ISession[] = Array.isArray(data)
  ? data.map((item, i) => ({
      ...item,
      id: item.session_id,
      index: i + 1,
    }))
  : [];



  useEffect(() => {
    dispatch(SessionRead());
  }, [addOrUpdateResponse, dispatch]);

  return (
    <>
      <Table rows={sessions} columns={columns}>
        <CustomToolbar>
          <h6>Sessions</h6>
          <TableSearch />
          <ButtonField
            onClick={() => setDialogOpen(true)}
            disabled={dialogOpen}
          >
            Add New
          </ButtonField>
          <IconButtonField
            onClick={() => dispatch(SessionRead())}
            toolTip="Refresh"
          >
            <SvgIcon component={RefreshButton} inheritViewBox />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${initialValues.session_id ? "Update" : "Add"} Session`}
        Dialog_Content={
          <SessionForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField onClick={() => setDialogOpen(false)}>
              Cancel
            </ButtonField>
            <ButtonField onClick={() => formRef.current?.requestSubmit()}>
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        okFunction={() => setDialogOpen(false)}
        response={addOrUpdateResponse}
        parentDialog={setDialogOpen}
      />

      {deleteDialogData && (
        <DeleteDialog
          deleteableName={deleteDialogData.description ?? ""}
          open={deleteDialogOpen}
          setOpen={setDeleteDialogOpen}
          deleteFunction={() => {
            dispatch(Session_Crud({ ...deleteDialogData, is_delete: true }));
          }}
          response={addOrUpdateResponse}
        />
      )}
    </>
  );
};

export default Session;
